<script setup>
import { ref, onMounted, computed, watch } from 'vue';
import { useRoute } from 'vue-router'
const route = useRoute()

import { useAuthStore } from '@/stores/authStore.js';
const authService = useAuthStore();

function logout() {
  if (confirm('Вы уверены что хотите выйти?'))
    authService.logout();
}

import companiesRequests from '@/requests/companiesRequests.js';
import Select from '@/components/Form/Select.vue';

import { useCompanyStore } from '@/stores/companyStore';

const companyStore = useCompanyStore();
const chosen_company = ref(companyStore.currentCompany || authService.user?.company_id);
const has_multiple_companies = ref(false);

watch(chosen_company, (newVal) => {
  companyStore.setCompany(newVal);
});

let my_companies = ref([]);

onMounted(async () => {
  if (!authService.user) {
    console.error('User data is not available');
    return;
  }

  try {
    if (authService.user.role !== 'client') {
      const my_companies_response = await companiesRequests.getMy().catch(err => {
        console.error('Failed to fetch companies:', err);
        throw err;
      });

      my_companies.value = my_companies_response.data.map(x => ({
        name: x.title ? x.title : 'id:' + x.id,
        value: x.id,
        obj: x
      }));

      has_multiple_companies.value = my_companies.value.length > 1;
      if (!has_multiple_companies.value && my_companies.value.length === 1) {
        chosen_company.value = my_companies.value[0].value;
        companyStore.setCompany(chosen_company.value);
        return;
      }

      if (!my_companies.value.some(x => x.value === authService.user.company_id)) {
        my_companies.value.push({
          name: authService.user.title,
          value: authService.user.company_id,
          obj: { id: authService.user.company_id, title: authService.user.title }
        });
      }

      try {
        const savedCompany = localStorage.getItem('selectedCompany');
        if (savedCompany && my_companies.value.some(c => c.value === savedCompany)) {
          chosen_company.value = savedCompany;
        }
      } catch (e) {
        console.error('LocalStorage access error:', e);
      }
    } else {
      my_companies.value = [{
        name: authService.user.title,
        value: authService.user.company_id,
        obj: { id: authService.user.company_id, title: authService.user.title }
      }];
      chosen_company.value = authService.user.company_id;
      companyStore.setCompany(chosen_company.value);
      has_multiple_companies.value = false;
    }
  } catch (error) {
    console.error('Error loading companies:', error);
  }
});

const isContractsActive = computed(() =>
  route.path.startsWith('/contracts')
)


</script>


<template>
  <nav class="navbar navbar-expand navbar-light bg-white d-flex justify-content-between p-3 ps-5 pe-5">
    <a href="https://saz-mars.ru/" target="_blank"
       class="text-decoration-none header-nav d-flex align-items-center">
      <img src="/logo.jpg" alt="Logo" class="d-block me-3" style="width: 140px; margin-left: -8px;">
      <span
        style="font-weight: 600; font-size: 20px; line-height: 24.2px; color:black; letter-spacing: 0.05em">СИСТЕМА
                АВТОМАТИЗАЦИИ<br> ЗАКУПОК</span>
    </a>
    <div class="text-decoration-none header-nav">
      <div class="d-flex mt-3 justify-content-end">
        <div class="flex-column me-2">
          <div class="d-flex justify-content-end align-items-center">
            <router-link to="/profile/my" class="text-decoration-none">
              <div class="me-3 d-flex flex-column profile" title="Профиль">
                <span style="line-height: 18.13px; font-size: 18px;" class="text-end">
                  {{ authService.user.title }}
                </span>
                <span style="line-height: 18.13px; font-size: 14px;" class="text-end">
                  {{ authService.user.login }}
                </span>
              </div>
            </router-link>
            <div class="dropdown mb-1">
              <div class="dropdown-toggle d-flex justify-content-center align-items-center" type="button" id="dropdownMenuButton1"
                   data-bs-toggle="dropdown" aria-expanded="false" title="Каталог">
                <button class="btn btn-primary pb-1 pt-1">
                  <i class="bi bi-gear text-white lh-1" style="font-size: 22px;" />
                </button>
              </div>
              <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton1">
                <router-link to="/catalogDocument"
                             v-if="authService.user.role != 'client' && authService.user.role != 'operator'"
                             class="dropdown-item">Документы</router-link>
                <router-link to="/catalog"
                             v-if="authService.user.role != 'client' && authService.user.role != 'operator'"
                             class="dropdown-item">Методы определения НМЦД</router-link>
                <router-link to="/catalogMethod"
                             v-if="authService.user.role != 'client' && authService.user.role != 'operator'"
                             class="dropdown-item">Способы закупки</router-link>
                <router-link to="/catalogService"
                             v-if="authService.user.role != 'client' && authService.user.role != 'operator'"
                             class="dropdown-item">Предметы закупки</router-link>
                <router-link to="/catalogRequirements"
                             v-if="authService.user.role != 'client' && authService.user.role != 'operator'"
                             class="dropdown-item">Единые (дополнительные) требования</router-link>
                <router-link to="/catalogInfoAndDocuments"
                             v-if="authService.user.role != 'client' && authService.user.role != 'operator'"
                             class="dropdown-item">Дополнительные требования, информация и
                  документы</router-link>
                <router-link to="/catalogExecPlace" class="dropdown-item">Место поставки товара
                  (выполнения
                  работ, оказания услуг)</router-link>
                <router-link to="/catalogDeliveryTerms"
                             v-if="authService.user.role != 'client' && authService.user.role != 'operator'"
                             class="dropdown-item">Условия поставки товара</router-link>
                <router-link to="/catalogServiceTerms"
                             v-if="authService.user.role != 'client' && authService.user.role != 'operator'"
                             class="dropdown-item">Условия оказания услуг</router-link>
                <router-link to="/catalogWorkTerms"
                             v-if="authService.user.role != 'client' && authService.user.role != 'operator'"
                             class="dropdown-item">Условия выполнения работ</router-link>
                <router-link to="/catalogServiceDocument"
                             v-if="authService.user.role != 'client' && authService.user.role != 'operator'"
                             class="dropdown-item">Товары, работы, услуги</router-link>
                <router-link to="/catalogEnsuring"
                             v-if="authService.user.role != 'client' && authService.user.role != 'operator'"
                             class="dropdown-item">Обеспечение</router-link>
                <router-link to="/catalogDocumentSubject"
                             v-if="authService.user.role != 'client' && authService.user.role != 'operator'"
                             class="dropdown-item">Документы по предмету закупки</router-link>
                <router-link to="/catalogTariffs" v-if="authService.user.role == 'admin'"
                             class="dropdown-item">Тарифы</router-link>
                <router-link to="/catalogFinancialResults"
                             v-if="authService.user.role != 'client' && authService.user.role != 'operator'"
                             class="dropdown-item">Финансовые результаты</router-link>
                <router-link to="/catalogFundingSources" class="dropdown-item">Источники
                  финансирования</router-link>
              </ul>
            </div>
            <div class="ms-2 mb-1">
              <router-link to="/login" title="Выход">
                <button @click="logout" class="btn-primary btn pb-1 pt-1" >
                  <i class="bi bi-door-open text-white lh-1" style="font-size: 22px;" />
                </button>
              </router-link>
            </div>
          </div>
          <div class="d-flex">
            <Select v-if="has_multiple_companies && authService.user.role != 'client'" v-model="chosen_company"
                    :options="my_companies" class=" mt-2" style="width: 450px;"
                    placeholder="Выбрать заказчика" searchable can-clear />
          </div>
        </div>
        <div>
        </div>
      </div>
    </div>
  </nav>
  <nav class="navbar navbar-expand navbar-light bg-primary d-flex justify-content-center ps-5 pe-5 w-100" style="height: 54px;">
    <ul class="navbar-nav w-100 justify-content-center gap-5" style="padding-top: 6px;">
      <router-link to="/" class="nav-item nav-link text-decoration-none header-nav">
        Главная
      </router-link>
      <router-link to="/profile/my" class="nav-item nav-link text-decoration-none header-nav">
        Профиль
      </router-link>
      <router-link to="/procurementsRules" class="nav-item nav-link text-decoration-none header-nav">
        Положение о закупке
      </router-link>
      <router-link to="/eisPlans" class="nav-item nav-link text-decoration-none header-nav">
        Планы закупки
      </router-link>
      <router-link to="/documents" class="nav-item nav-link text-decoration-none header-nav">
        Реестр закупок
      </router-link>
      <router-link to="/contracts/register" class="nav-item nav-link text-decoration-none header-nav" :class="{ 'router-link-active': isContractsActive }">
        Исполнение договоров
      </router-link>
      <a href="#" class="nav-item nav-link text-decoration-none header-nav">
        Услуги
      </a>
      <a href="https://etp-mir.ru/" target="_blank" class="nav-item nav-link text-decoration-none header-nav">
        ЭТП МИР
      </a>
    </ul>
  </nav>
</template>

<style scoped>
.navbar-nav .nav-link.nav-item:first-child {
  padding-left: 0 !important;
}

.dropdown-toggle {
  border: none;
}

.dropdown-toggle::after {
  display: none;
}

.nav-link:not(.active) {
  color: white;
}

.nav-link {
  line-height: 18.75px;
  font-size: 16px;
}

.nav-link:hover {
  color: var(--bs-secondary)
}

.profile:hover > span {
  color: var(--bs-secondary);
}

.profile > span {
  cursor: pointer;
}
</style>